import React, { useMemo, useState } from 'react';
import { Row, TabPanel, Tabs, HeadingText } from '@paypalcorp/pp-react';
import EnvSetUp from '../EnvSetUp/EnvSetUp';
import styles from './MultiLangEvnSetup.module.less';
import { useSearchParams } from 'react-router-dom';
import { trackTabClick } from '../../../../lib/fpti';

const MultiLangEnvSetup = ({ multiEnv, title }) => {
  const { tabsList, envData } = useMemo(() => {
    const tabsList = [];
    const envData = {};

    multiEnv.forEach((envItem) => {
      const { key, label, devEnvSetup } = envItem;
      envData[key] = devEnvSetup.contents;
      tabsList.push({
        id: key,
        panelId: key,
        label: label
      });
    });

    return { tabsList, envData };
  }, [multiEnv]);

  const [query] = useSearchParams();
  const backendLang = query.get('backend');

  const getSelectedLanguage = () => {
    if (!backendLang) {
      return 0;
    }
    const index = tabsList.findIndex((item) => item.id === backendLang);
    return index === -1 ? 0 : index;
  };

  const [selectedTabIdx, setSelectedTabIdx] = useState(getSelectedLanguage);

  return (
    <div>
      <Row className={`${styles.dev_env_title}`}>
        <HeadingText size="lg" type="medium">
          {title}
        </HeadingText>
      </Row>
      <Tabs
        name="DevEnvSetupTabs"
        selectedTabIdx={selectedTabIdx}
        tabs={tabsList}
        onClick={(e, idx) => {
          trackTabClick(tabsList[idx].label);
          setSelectedTabIdx(idx);
        }}
        className={styles.tabs}
      >
        {tabsList.map((tab) => (
          <TabPanel
            id={tab.panelId}
            tabId={tab.panelId}
            className={styles.tab_panel}
            key={tab.panelId}
          >
            <EnvSetUp devEnv={envData[tab.id]} />
          </TabPanel>
        ))}
      </Tabs>
    </div>
  );
};

export default MultiLangEnvSetup;
